import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="container">
        <section className="section">
          <h2>About Us</h2>
          <div className="card">
            <h3>Mission</h3>
            <p>At Swim With a Splash, our mission is to give back to the community by teaching children essential swimming skills. Swimming is not only a fun activity but also a critical life skill. We are committed to helping kids feel safe and confident in the water—whether their goal is to simply enjoy time at the pool or to swim faster with stronger technique</p>
            
            <h3>Who We Are</h3>
            <p>We are a team of passionate competitive swimmers from some of the top clubs in the nation. Since 2023, Swim With a Splash has been bringing high-quality swim lessons and water safety education to local communities. Swim With a Splash is a 501(c)(3) nonprofit organization, and our coaches are dedicated to sharing their love of swimming while helping each child grow in skill, safety, and confidence.</p>
            
            <h3>What We Offer</h3>
            <p><strong>Learn‑to‑Swim:</strong> This is geared towards children who want to learn how to swim or are in the elementary steps.</p>
            <p><strong>Stroke Clinic:</strong> If your child is proficient in their strokes, we will help polish your child's skills to bring them to competitive standards.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
